<template>
    <div>
        <GridPage
            :form-default="{
                status: 'pending',
            }"
            :filters-default="{
                status: '',
                sort: 'name',
            }"
            :filter-items="[
                {
                    vModel: 'status',
                    title: '状態',
                    options: [
                        { text: '全て', value: '' },
                        { text: '準備', value: 'pending' },
                        { text: '受付', value: 'activated' },
                        { text: '締切', value: 'closed' },
                    ],
                },
                {
                    vModel: 'sort',
                    title: '順番',
                    options: [
                        {
                            text: '▲ 名前',
                            value: 'name',
                        },
                        { text: '▼ 名前', value: '-name' },
                    ],
                },
            ]"
            filters-q-placeholder="名前"
            form-modal-id="form"
            search-action="form/index"
            >
            <template v-slot:form="{ form, init }">
                <Form :model="form" :init="init"></Form>
            </template>

            <template>
                <b-col md="6"> 名前 </b-col>
                <b-col md="6"> メール </b-col>
            </template>

            <template v-slot:column="{ item }">
                <b-col md="6" class="align-self-center">
                    <FormBadges :model="item" class="mb-1" />
    
                    <p class="mb-1">
                        {{ item.name }}
                    </p>

                    <div class="mb-1">
                        <FormDate :model="item" />
                    </div>
                </b-col>
    
                <b-col md="6" class="align-self-center">
                    <FormInfo :model="item" />
                </b-col>
            </template>
        </GridPage>

        <b-link :href="`/f/${auth_uuid}/`" target="_blank">
            公開ページを表示する
            <font-awesome-icon class="fa-fw" icon="external-link-alt" />
        </b-link>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GridPage from '@/components/GridPage.vue'
import Form from '@/components/Form.vue'
import FormBadges from '@/components/FormBadges.vue'
import FormDate from '@/components/FormDate.vue'
import FormInfo from '@/components/FormInfo.vue'

export default {
    components: {
        GridPage,
        Form,
        FormBadges,
        FormDate,
        FormInfo,
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'auth_uuid',
            'trans',
        ])
    },
    data() {
        return {}
    },
    methods: {
    },
}
</script>

